
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorChatActivo } from '../../controlador';
    import { Transporte } from '@/__env/lib/Expedicion/Transportes';
    import { Cliente } from '@/__env/lib/Clientes';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import editar_envio from './barra-ventas-editar-envio.vue';
    import declaracion from './barra-ventas-subir-declaracion.vue';
    import detalles from './barra-ventas-pedidos-detalles.vue';
    import { Wait } from '@/__env/ext';
    import { Utiles } from '@/__env/pluggins/event-bus';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            editar_envio,
            declaracion,
            detalles,
        }
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorChatActivo;
        public get Chat() { return this.Controlador.Chat; }
        public get ReservarEspacioDerecha() { return this.Controlador.Vista.ReservarEspacioDerecha.Espacio; }
        public get ControladorBarras() { return this.Controlador.ControladorBarrasLaterales; }
        public get ModoDeArchivoSeleccionado() { return this.ControladorBarras.ModoDeArchivoSeleccionado; }
        public get Modo() { return this.ControladorBarras.Vista.Modo; }
        public set Modo( x: string ) { this.ControladorBarras.Vista.Modo = x; }
        public get SubModo() { return this.ControladorBarras.Vista.SubModo; }
        public set SubModo( x: string ) { this.ControladorBarras.Vista.SubModo = x; }
        public Pedidos: Pedido[] = [];

        public SoloPendientes: boolean = false;
        @Watch( 'SoloPendientes' )
        onSoloPendientes()
        {
            this.Iniciar();
        }

        public Cargando: boolean = false;

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }
        mounted()
        {
            this.Eventos.push( this.ControladorBarras.Vista.onSubModo.subscribe( () =>
            {
                if ( this.SubModo == 'pedidos' )
                {
                    this.Controlador.Vista.ReservarEspacioDerecha.Espacio = 400;
                }
            } ) );

            this.SubModo = 'pedidos';
            this.Iniciar();
        }

        async Iniciar()
        {
            this.Cargando = true;
            this.Pedidos.clear();
            let bb: any = { cliente: this.Chat.Cliente.Id, order: 'fecha', sort: 'DESC' };
            if ( this.SoloPendientes )
            {
                bb.tags = 'pendientes';
            }

            let e = await Pedido.find( bb );
            if ( e.Items.hasRows() )
                this.Pedidos = e.Items;
            this.Cargando = false;
        }





        public async Abrir( item: Pedido )
        {
            if ( this.ModoDeArchivoSeleccionado == 'declaracion_iibb' )
            {
                let r = await Utiles.Mensajes.SiNoCancelar( 'Guardar declaración jurada', `¿Está seguro de subir el archivo?` );
                if ( r == 's' )
                {
                    let e = await item.SubirDeclararionIIBB( this.ControladorBarras.ArchivoSeleccionado );
                    if ( e )
                    {
                        this.Cerrar();
                        this.$EventBus.Notificaciones.Completado( 'Guardado correctamente' );
                    }
                    else
                    {
                        this.$EventBus.Notificaciones.Error( 'Error al guardar el archivo' );
                    }
                }
                else if ( r == 'c' )
                {
                    this.Cerrar();
                }


            } else
            {
                this.Controlador.ControladorBarrasLaterales.PedidoSeleccionado = item;
                await Wait( 50 );
                this.SubModo = 'pedidos-detalles';
            }

        }

        public async EditarSubModo( item: Pedido, modo: string )
        {
            if ( modo == 'pedidos-abrir' )
            {
                window.open( '/#/pedido/' + item.Id );
            } else
            {
                this.Controlador.ControladorBarrasLaterales.PedidoSeleccionado = item;
                await Wait( 50 );
                this.SubModo = modo;
            }

        }

        Cerrar()
        {
            if ( ['declaracion_iibb'].includes( this.ControladorBarras.ModoDeArchivoSeleccionado ) )
            {
                this.ControladorBarras.ArchivoSeleccionado = '';
                this.ControladorBarras.ModoDeArchivoSeleccionado = '';
                this.Modo = '';
            } else
            {
                this.Modo = 'menu';
            }
        }

        public Refresh: boolean = false;
        Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }
    }
